import { httpRequest } from "../../http";
import { IngestRun } from "@models/IngestRun.model";

export class CommandListFiles {
  /** organizationId is the auth scope; ingestDefinitionId narrows to one
   *  definition's runs (the config-scoped file lists). */
  async run(organizationId: number, ingestDefinitionId?: number): Promise<IngestRun[]> {
    const params = new URLSearchParams({ organization_id: String(organizationId) });
    if (ingestDefinitionId != null) params.set("ingest_definition_id", String(ingestDefinitionId));
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/?${params}`;
    return httpRequest<IngestRun[]>(url, { method: "GET" });
  }
}
